import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TTab } from '../components/common/tabs/TabsController';

type TInformationSlice = Record<string, Record<string, unknown>> & {
  tabs: { list: TTab[] };
};

/**
 * This slice is intended to keep information about any component with debug
 * purposes.
 */
const informationSlice = createSlice({
  name: 'informationSlice',
  initialState: {} as TInformationSlice,
  reducers: {
    update(
      state,
      {
        payload: { id, ...rest },
      }: PayloadAction<{ id: string; [key: string]: unknown }>,
    ) {
      state[id] = { ...state[id], ...rest };
    },
    remove(state, { payload: { id } }: PayloadAction<{ id: string }>) {
      delete state[id];
    },
  },
});

export const informationActions = informationSlice.actions;
export default informationSlice.reducer;
